import React, { lazy } from "react";
import { Routes, Route } from "react-router-dom";
import AuthGuard from "src/guard/authguard/AuthGuard";
import GuestGuard from "src/guard/guestguard/GuestGuard";
import DashboardLayout from "src/layouts/dashboard-layout/DashboardLayout";
import AuthLayout from "src/layouts/auth-layout/AuthLayout";
import PublicLayout from "src/layouts/public-layout/PublicLayout";
const RouteComponent = () => {
  return (
    <>
      <Routes>
        {route.map((route, index) => {
          const Components = route.component;
          const Layout = route.layout || React.Fragment;
          const Guard =
            route.guard === "guest"
              ? GuestGuard
              : route.guard === "auth"
                ? AuthGuard
                : React.Fragment;
          return (
            <Route
              key={index}
              path={route.path}
              element={
                <Guard requiredRole={route.requiredRole}>
                  <Layout>
                    <Components />
                  </Layout>
                </Guard>
              }
            />
          );
        })}
      </Routes>
    </>
  );
};

const route = [
  {
    path: "/",
    component: lazy(() => import("../views/website/landing/index")),
    guard: "guest",
    layout: PublicLayout,
  },
  {
    path: "/security",
    component: lazy(() => import("../views/website/security/Security")),
    guard: "guest",
    layout: PublicLayout,
  },
  {
    path: "/pricing-plan",
    component: lazy(() => import("../views/website/pricing/Pricing")),
    guard: "guest",
    layout: PublicLayout,
  },
  {
    path: "/documentation",
    component: lazy(() => import("../views/website/documentations/Documentation")),
    guard: "guest",
    layout: PublicLayout,
  },
  {
    path: "/documentation/getting-started",
    component: lazy(() => import("../views/website/documentations/components/documentation-category-types/DocumentationGettingStarted")),
    guard: "guest",
    layout: PublicLayout,
  },
  {
    path: "/documentation/security",
    component: lazy(() => import("../views/website/documentations/components/documentation-category-types/SecurityDocumentation")),
    guard: "guest",
    layout: PublicLayout,
  },
  {
    path: "/documentation/Communication",
    component: lazy(() => import("../views/website/documentations/components/documentation-category-types/CommunicationDocumentation")),
    guard: "guest",
    layout: PublicLayout,
  },
  {
    path: "/documentation/account",
    component: lazy(() => import("../views/website/documentations/components/documentation-category-types/AccountDocumentation")),
    guard: "guest",
    layout: PublicLayout,
  },
  {
    path: "/documentation/billing",
    component: lazy(() => import("../views/website/documentations/components/documentation-category-types/BillingDocumentation")),
    guard: "guest",
    layout: PublicLayout,
  },
  {
    path: "/documentation/company",
    component: lazy(() => import("../views/website/documentations/components/documentation-category-types/CompanyDocumentation")),
    guard: "guest",
    layout: PublicLayout,
  },
  {
    path: "/documentation-cta",
    component: lazy(() => import("../views/website/documentations/components/DocumentationCTA")),
    guard: "guest",
    layout: PublicLayout,
  },
  {
    path: "/faq",
    component: lazy(() => import("../views/website/faq/Faq")),
    guard: "guest",
    layout: PublicLayout,
  },
  {
    path: "/help-center",
    component: lazy(() => import("../views/website/help-center/HelpCenter")),
    guard: "guest",
    layout: PublicLayout,
  },
  {
    path: "/about-us",
    component: lazy(() => import("../views/website/about-crypsyn/AboutCrypsyn")),
    guard: "guest",
    layout: PublicLayout,
  },
  {
    path: "/mailfinance-ag",
    component: lazy(() => import("../views/website/mailfinance-ag/MailfinanceAg")),
    guard: "guest",
    layout: PublicLayout,
  },
  {
    path: "/contact",
    component: lazy(() => import("../views/website/contact/Contact")),
    guard: "guest",
    layout: PublicLayout,
  },
  {
    path: "/privacy-policy",
    component: lazy(() => import("../views/website/privacy/PrivacyPolicy")),
    guard: "guest",
    layout: PublicLayout,
  },
  {
    path: "/terms-and-conditions",
    component: lazy(() => import("../views/website/terms-and-conditions/TermsAndConditions")),
    guard: "guest",
    layout: PublicLayout,
  },
  {
    path: "/signin",
    component: lazy(() => import("../auth/Signin/Signin")),
    guard: "guest",
    layout: AuthLayout,
  },
  {
    path: "/register-portal/:token/:plan_id/:plan_name",
    component: lazy(() => import("../views/superadmin/pages/portal/index")),
    guard: "guest",
    layout: AuthLayout,
  },
  {
    path: "/test",
    component: lazy(() => import("../views/pages/test/Test")),
    guard: "auth",
    requiredRole: ["super_admin", "admin", "user", "employee"],
    layout: DashboardLayout,
  },
  {
    path: "/signup",
    component: lazy(() => import("../auth/Signup/Signup")),
    guard: "guest",
    layout: AuthLayout,
  },
  {
    path: "/forgetpassword",
    component: lazy(() => import("../auth/forgetpassword/ForgetPassword")),
    guard: "guest",
    layout: AuthLayout,
  },
  {
    path: "/forgettoken",
    component: lazy(() => import("../auth/forgettoken/ForgetToken")),
    guard: "guest",
    layout: AuthLayout,
  },
  {
    path: "/passwordandconfirmpassword",
    component: lazy(() => import("../auth/Signup/PassConfirmPass")),
    guard: "guest",
    layout: AuthLayout,
  },
  {
    path: "/newpasswordandconfirmpassword",
    component: lazy(
      () =>
        import("../auth/commonnewpassandconfirmpass/CommonNewPassAndConfirmPass"),
    ),
    guard: "guest",
    layout: AuthLayout,
  },
  {
    path: "/otpvalidation",
    component: lazy(() => import("../auth/otpvalidation/OtpValidation")),
    guard: "guest",
    layout: AuthLayout,
  },
  {
    path: "/blog",
    component: lazy(
      () => import("../views/website/blog/Blog"),
    ),
    guard: "guest",
    layout: PublicLayout,
  },
  {
    path: "/dashboard",
    component: lazy(() => import("../views/superadmin/index")),
    guard: "auth",
    requiredRole: ["super_admin"],
    layout: DashboardLayout,
  },
  {
    path: "/admin-dashboard",
    component: lazy(() => import("../views/admin/index")),
    guard: "auth",
    requiredRole: ["admin"],
    layout: DashboardLayout,
  },
  {
    path: "/inbox",
    component: lazy(() => import("../views/pages/inbox/index")),
    guard: "auth",
    requiredRole: ["super_admin", "admin", "user", "employee"],
    layout: DashboardLayout,
  },
  {
    path: "/inboxdetails/:id",
    component: lazy(
      () => import("../views/pages/inbox/inboxdetails/InboxDetails"),
    ),
    guard: "auth",
    requiredRole: ["super_admin", "admin", "user", "employee"],
    layout: DashboardLayout,
  },
  {
    path: "/drafts",
    component: lazy(() => import("../views/pages/draft/index")),
    guard: "auth",
    requiredRole: ["super_admin", "admin", "user", "employee"],
    layout: DashboardLayout,
  },
  {
    path: "/sent",
    component: lazy(() => import("../views/pages/send/index")),
    guard: "auth",
    requiredRole: ["super_admin", "admin", "user", "employee"],
    layout: DashboardLayout,
  },
  {
    path: "/senddetails/:id",
    component: lazy(
      () => import("../views/pages/send/senddetails/SendDetails"),
    ),
    guard: "auth",
    requiredRole: ["super_admin", "admin", "user", "employee"],
    layout: DashboardLayout,
  },
  {
    path: "/starred",
    component: lazy(() => import("../views/pages/starred/index")),
    guard: "auth",
    requiredRole: ["super_admin", "admin", "user", "employee"],
    layout: DashboardLayout,
  },
  {
    path: "/starreddetails/:id",
    component: lazy(
      () => import("../views/pages/starred/starreddetails/StarredDetails"),
    ),
    guard: "auth",
    requiredRole: ["super_admin", "admin", "user", "employee"],
    layout: DashboardLayout,
  },
  {
    path: "/archive",
    component: lazy(() => import("../views/pages/archive/index")),
    guard: "auth",
    requiredRole: ["super_admin", "admin", "user", "employee"],
    layout: DashboardLayout,
  },
  {
    path: "/archivedetails/:id",
    component: lazy(
      () => import("../views/pages/archive/archivedetails/ArchiveDetails"),
    ),
    guard: "auth",
    requiredRole: ["super_admin", "admin", "user", "employee"],
    layout: DashboardLayout,
  },
  {
    path: "/trash",
    component: lazy(() => import("../views/pages/trash/index")),
    guard: "auth",
    requiredRole: ["super_admin", "admin", "user", "employee"],
    layout: DashboardLayout,
  },
  {
    path: "/trashdetails/:id",
    component: lazy(
      () => import("../views/pages/trash/trashdetails/TrashDetails"),
    ),
    guard: "auth",
    requiredRole: ["super_admin", "admin", "user", "employee"],
    layout: DashboardLayout,
  },
  {
    path: "/settings",
    component: lazy(() => import("../views/pages/settings/index")),
    guard: "auth",
    requiredRole: ["super_admin", "admin", "user", "employee"],
    layout: DashboardLayout,
  },
  {
    path: "/profile",
    component: lazy(() => import("../views/pages/profile/Profile")),
    guard: "auth",
    requiredRole: ["super_admin", "admin", "user", "employee"],
    layout: DashboardLayout,
  },
  {
    path: "/notifications",
    component: lazy(() => import("../views/admin/notification/Notification")),
    guard: "auth",
    requiredRole: ["super_admin", "admin", "user", "employee"],
    layout: DashboardLayout,
  },
  {
    path: "/control-panel/plans",
    component: lazy(() => import("../views/superadmin/pages/plans/index")),
    guard: "auth",
    requiredRole: ["super_admin"],
    layout: DashboardLayout,
  },
  {
    path: "/control-panel",
    component: lazy(
      () => import("../views/superadmin/pages/control-panel/index"),
    ),
    guard: "auth",
    requiredRole: ["super_admin"],
    layout: DashboardLayout,
  },
  {
    path: "/control-panel/create-company",
    component: lazy(
      () => import("../views/superadmin/pages/create-account/CreateCompany"),
    ),
    guard: "auth",
    requiredRole: ["super_admin"],
    layout: DashboardLayout,
  },
  {
    path: "/control-panel/create-admin",
    component: lazy(
      () => import("../views/superadmin/pages/create-account/CreateAdmin"),
    ),
    guard: "auth",
    requiredRole: ["super_admin"],
    layout: DashboardLayout,
  },
  {
    path: "/control-panel/user-management",
    component: lazy(
      () => import("../views/superadmin/pages/user-management/index"),
    ),
    guard: "auth",
    requiredRole: ["super_admin"],
    layout: DashboardLayout,
  },
  {
    path: "/control-panel/user-verification",
    component: lazy(
      () => import("../views/superadmin/pages/user-verification/index"),
    ),
    guard: "auth",
    requiredRole: ["super_admin"],
    layout: DashboardLayout,
  },
  {
    path: "/control-panel/organization-management",
    component: lazy(
      () => import("../views/superadmin/pages/company-list/CompanyList"),
    ),
    guard: "auth",
    requiredRole: ["super_admin"],
    layout: DashboardLayout,
  },
  {
    path: "/control-panel/logs",
    component: lazy(() => import("../views/superadmin/pages/log-folder/Logs")),
    guard: "auth",
    requiredRole: ["super_admin"],
    layout: DashboardLayout,
  },
  {
    path: "/create-account/add-employee-details",
    component: lazy(
      () => import("../views/admin/create-account/AddEmployeeDetails"),
    ),
    guard: "auth",
    requiredRole: ["admin"],
    layout: DashboardLayout,
  },
  {
    path: "/create-account/add-employee-credential",
    component: lazy(
      () => import("../views/admin/create-account/AddEmployeeCredential"),
    ),
    guard: "auth",
    requiredRole: ["admin"],
    layout: DashboardLayout,
  },
  {
    path: "/manage-team",
    component: lazy(() => import("../views/admin/manage-team/ManageTeam")),
    guard: "auth",
    requiredRole: ["admin"],
    layout: DashboardLayout,
  },
  {
    path: "/membership-plan-history",
    component: lazy(
      () =>
        import("../views/admin/membership-plan-history/MemberShipPlanHistory"),
    ),
    guard: "auth",
    requiredRole: ["admin"],
    layout: DashboardLayout,
  },
  {
    path: "*",
    component: lazy(() => import("../views/pages/notfound/NotFound")),
  },
];

export default RouteComponent;
